import React, { useEffect } from 'react'
import { unstable_HistoryRouter as HistoryRouter, useNavigate } from 'react-router-dom'
import { appHistory, setNavigate } from 'utils/navigation'
import LocationSync from './LocationSync'
import AppRoutes from './AppRoutes'

function NavigationRefBinder() {
  const navigate = useNavigate()

  useEffect(() => {
    setNavigate(navigate)
    return () => setNavigate(null)
  }, [navigate])

  return null
}

export default function AppRouter({ store, onUpdate }) {
  return (
    <HistoryRouter
      history={appHistory}
      future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <NavigationRefBinder />
      <LocationSync onUpdate={onUpdate} />
      <AppRoutes store={store} />
    </HistoryRouter>
  )
}
